/* COmmon Imports */

import React from "react";
import { withRouter } from "next/router";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import Layout from "../../components/layout-components/Layout";
import Searchbar from "../../components/page-sections/properties/SearchbarWODropdowns";
import InfiniteScroller from "../../components/page-sections/properties/InfiniteScroller";
import ShareModal from "../../components/modals/ShareModal";
import DownloadModal from "../../components/modals/DownloadModal";

/* Data Imports */

import AppConfig from "../../AppConfig";

/* Redux Imports */

import { createStore, applyMiddleware } from "redux";
import GlobalReducer from "../../components/redux-components/GlobalReducer";
import { Provider } from "react-redux";
import thunk from "redux-thunk";

/* Create Redux Store */

const reduxStore = createStore(GlobalReducer, applyMiddleware(thunk));
const Properties = () => {
  const [openShare, setOpenShare] = React.useState(false);
  const [slug, setSlug] = React.useState(undefined);
  const [url, setUrl] = React.useState(undefined);
  const [title, setTitle] = React.useState(undefined);
  const [openDownload, setOpenDownload] = React.useState(false);
  const [pdf, setPdf] = React.useState(undefined);
  React.useEffect(() => {
    window.addEventListener("hashchange", hashListener);
  }, []);
  function hashListener() {
    setSlug(window.location.hash.split("@").slice(1, 2).join("@"));
    setUrl(window.location.hash.split("@").slice(2, 3).join("@"));
    setTitle(window.location.hash.split("@").slice(3, 4).join("@"));
    setPdf(window.location.hash.split("@").slice(4, 5).join("@"));
    if (window.location.hash.substring(0, 6) == "#share") {
      setOpenShare(true);
    } else if (window.location.hash.substring(0, 9) == "#download") {
      setOpenDownload(true);
    }
  }
  const handleClose = () => {
    setOpenShare(false);
    setOpenDownload(false);
    window.location.hash = "";
  };

  /* Define all styles */

  const useStyles = makeStyles((theme) => ({
    searchbarGlobal: {
      position: "fixed",
      width: "100%",
      top: "4rem",
      zIndex: "5",
      backgroundColor: "#FFFFFF",
      /* XXS breakpoint */
      [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
        margin: "0rem -0.5rem 0rem -0.5rem",
        padding: "0rem 0.5rem 0rem 0.5rem",
        borderRadius: "0px 0px 4px 4px",
      },
      [theme.breakpoints.only("xs")]: {
        margin: "0rem -1.5rem 0rem -1.5rem",
        padding: "0rem 1.5rem 0rem 1.5rem",
        borderRadius: "0px 0px 4px 4px",
      },
      [theme.breakpoints.only("sm")]: {
        margin: "0rem -3rem 0rem -3rem",
        padding: "0rem 3rem 0rem 3rem",
      },
      [theme.breakpoints.only("md")]: {
        margin: "0rem -4rem 0rem -4rem",
        padding: "0rem 4rem 0rem 4rem",
      },
      [theme.breakpoints.only("lg")]: {
        margin: "0rem -4rem 0rem -4rem",
        padding: "0rem 4rem 0rem 4rem",
      },
      /* XLG breakpoint */
      [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
        margin: "0rem -5rem 0rem -5rem",
        padding: "0rem 5rem 0rem 5rem",
      },
      /* Full HD breakpoint */
      [theme.breakpoints.up("xl")]: {
        margin: "0rem -23rem 0rem -23rem",
        padding: "0rem 23rem 0rem 23rem",
      },
      /* XXL breakpoint */
      [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
        margin: "0rem -36rem 0rem -36rem",
        padding: "0rem 36rem 0rem 36rem",
      },
      /* XXXL breakpoint */
      [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
        margin: "0rem -72rem 0rem -72rem",
        padding: "0rem 72rem 0rem 72rem",
      },
    },
  }));

  /* Footer State */

  const [footer, setFooter] = React.useState(false);

  /* Search Result Count State */

  const [numResults, setNumResults] = React.useState(0);

  /* Sticky Searchbar */

  const STICKY_SEARCHBAR =
    process.env.STICKY_SEARCHBAR_ON_PROPERTIES_PAGE === "true";

  /* Track the scroll trigger */

  const [scrollTrigger, setScrollTrigger] = React.useState(false);

  const classes = useStyles();
  return (
    <Provider store={reduxStore}>
      <React.Fragment>
        <Layout
          hideFooter={footer}
          navbarElevation={STICKY_SEARCHBAR ? 0 : undefined}
          onScrollTrigger={(state) => {
            setScrollTrigger(state);
          }}
        >
          <ShareModal
            open={openShare}
            onClose={handleClose}
            url={AppConfig.urlPrefix + "properties/" + slug}
          />
          <DownloadModal
            title={title}
            pdfHref={url}
            open={openDownload}
            onClose={handleClose}
            url={AppConfig.urlPrefix + "properties/" + slug}
            source={"download-pdf/" + slug}
            usePDFGenerator={pdf === "false"}
            slug={slug}
          />

          <Searchbar
            numResults={numResults}
            place={(place) => {
              setPlace(place);
            }}
            classNameGlobal={
              STICKY_SEARCHBAR ? classes.searchbarGlobal : undefined
            }
            classNameForm={STICKY_SEARCHBAR ? classes.searchbarForm : undefined}
            styleGlobal={
              STICKY_SEARCHBAR
                ? {
                    boxShadow: scrollTrigger
                      ? "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)"
                      : undefined,
                  }
                : undefined
            }
            scrollTrigger={scrollTrigger}
          />
          <InfiniteScroller
            iocb={(footerState) => {
              setFooter(footerState);
            }}
            numResults={(numResults) => {
              setNumResults(numResults);
            }}
            scrollTrigger={scrollTrigger}
          />
        </Layout>
      </React.Fragment>
    </Provider>
  );
};
export default withRouter(Properties);
